<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 pt-0>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <!-- <th class="text-left text-uppercase">Image</th> -->
                <th class="text-left text-uppercase">Shop Name</th>
                <th class="text-left text-uppercase">Phone</th>
                <th class="text-left text-uppercase">Place</th>
                <th class="text-left text-uppercase">Status</th>
                <th class="text-left text-uppercase">Action</th>
                <!-- <th class="text-left">Reserved Seats</th>
                <th class="text-left">Free</th> -->
              </tr>
            </thead>
            <tbody>
              <tr style="height:90px"  v-for="(item, i) in sellerData" :key="i">
                <!-- <td>
                  <v-layout wrap>
                    <v-flex xs12 align-self-center>
                      <v-img width="80px" height="85px" contain :src="mediaURL + item.sellerid.photo"></v-img>
                    </v-flex>
                  </v-layout>
                </td> -->

                <td>{{ item.organization }}</td>
                <td> {{ item.phone }}</td>
                <td> {{ item.locality }}</td>
                
                <td>{{ item.status }}</td>
                <td>
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm3 lg12 align-self-center>
                      <v-btn plain text :to="'/SellerInfo?seller='+ item._id">
                      <v-icon color="green" >mdi-eye</v-icon>
                      </v-btn>
                    </v-flex>
                      <!-- <v-flex xs12 sm4 align-self-center>
                        <v-icon color="blue">mdi-pencil</v-icon>
                      </v-flex>
                      <v-flex xs12 sm4 align-self-center>
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-flex> -->
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    
    <!-- <v-dialog persistent v-model="editDialog" max-width="70%">
      <v-card>
        <v-card-title style="font-family:poppinssemibold;font-size:16px"
          >Request</v-card-title
        >
        <v-layout wrap>
          <v-flex xs12 align-self-center px-6>
            <v-layout wrap pt-2>
              <v-flex xs12 sm6 text-left>
                <span>Seller Code</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.usercode}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.sellerProfileId">
              <v-flex xs12 sm6 text-left>
                <span>Seller Name</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.sellerProfileId.name}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.email">
              <v-flex xs12 sm6 text-left>
                <span>Email</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.email}}</span>
              </v-flex>
            </v-layout>
            <v-layout wrap pt-2 v-if="editingItem.phone">
              <v-flex xs12 sm6 text-left>
                <span>Phone</span>
              </v-flex>
              <v-flex xs12 sm6 text-left>
                <span>{{ editingItem.phone}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="getData(), (updateDialog = false)"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="updateStatus(dialogId, dialogStatus)"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["sellerData", "pages", "filter"],
  // props: ["fromDate","toDate","programme"],
  data() {
    return {
      currentPage: 1,
      // pages: 0,
      // sellerData: [],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
    };
  },
  // watch: {
  //   currentPage() {
  //     this.winStepper();
  //   },
  // },

  watch: {
    fromDate() {
      // this.getData()
    },
    toDate() {
      // this.getData()
    },
    programme() {
      // this.getData()
    },
    currentPage() {
      // this.getData();
      this.winStepper();
    },
  },
  beforeMount() {
    // this.getData()
    this.winStepper();
  },
  methods: {
    winStepper() {
      // console.log("step", this.currentPage);
      // alert("my call win comp")
      this.$emit("stepper", {
        getData: true,
        currentPage: this.currentPage,
        pages: this.pages,
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/users/list",
        headers: {
          "token": localStorage.getItem("token"),
        },
        params: {
          role: 'Seller',
          status: this.filter,
          count: 12,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.sellers = response.data.data;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>